import { Language } from "src/app/shared/config/app.constants";

export interface SafeDropLocation {
  desc: string;
  cd: string;
  descEn: string;
  descFr: string
}

export interface SafeDropLocationDTO {
  descEn: string;
  descFr: string;
  cd: string;
}

export class SafeDropLocationImpl implements SafeDropLocation {
  cd: string;
  desc: string;
  descEn: string;
  descFr: string;

  static locationFactory(locationDTO: SafeDropLocationDTO, currentLang: string) {
    const location = new SafeDropLocationImpl();
    location.cd = locationDTO.cd;
    location.desc = currentLang == Language.FRENCH ? locationDTO.descFr : locationDTO.descEn;
    location.descEn = locationDTO.descEn;
    location.descFr = locationDTO.descFr;
    return location;
  }
}
